module.exports = __webpack_public_path__ + "img/banner-princiapal.081d9d1f.svg";